// app.config.ts
import { ApplicationConfig, APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app/routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from './environments/environment';
import { AuthConfig, OAuthService, OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
// import { provideFirebaseApp } from '@angular/fire/app';
// import { provideMessaging, getMessaging } from '@angular/fire/messaging';
// import { initializeApp } from 'firebase/app';

import { MAT_BOTTOM_SHEET_DEFAULT_OPTIONS } from '@angular/material/bottom-sheet';

import {
  AngularMaterialModule,
  provideScanbotConfig
} from '@ftr/common-ui-components';

import {
  ConfigurationSet,
  CoreConfiguration,
  CoreConfigurationService,
  OwaCoreModule,
} from '@ftr/owa-core';

import { TimeKeepingConfiguration } from '@ftr/owa-timekeeping';
import { JobEnvConfiguration } from '@ftr/owa-jobs';
import { UserConfiguration } from '@ftr/owa-users';
import { LoginGuard } from './app/loginguard';
import { LunchGuard } from './app/lunchguard';
import { ProfileResolver } from './app/profile.resolver';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MatLegacySnackBarModule } from '@angular/material/legacy-snack-bar';
import { MAT_LEGACY_DIALOG_DEFAULT_OPTIONS, MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { oauthStorageFactory } from './app/oauth-storage.factory';
import { configureOAuthForIframe } from './app/oauth-iframe.initializer';

const CONFIG = new ConfigurationSet(new Map<string, any>([
  [AuthConfig.name, environment.authConfig],
  [CoreConfiguration.name, environment.coreConfiguration],
  [TimeKeepingConfiguration.name, environment.timeKeepingConfiguration],
  [JobEnvConfiguration.name, environment.jobConfiguration],
  [UserConfiguration.name, environment.userConfiguration]
]))

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideAnimations(),
    // provideFirebaseApp(() => initializeApp(environment.coreConfiguration.firebaseConfig)),
    // provideMessaging(() => getMessaging()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideScanbotConfig({ licenseKey: environment.scanBotLicense }),

    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { closeOnNavigation: false, hasBackdrop: true }
    },
    {
      provide: MAT_LEGACY_DIALOG_DEFAULT_OPTIONS,
      useValue: { closeOnNavigation: false, hasBackdrop: true }
    },
    {
      provide: MAT_BOTTOM_SHEET_DEFAULT_OPTIONS,
      useValue: { closeOnNavigation: false, hasBackdrop: true }
    },
    importProvidersFrom(
      OwaCoreModule.forRoot(CONFIG),
      AngularMaterialModule,
      MatSnackBarModule,
      MatLegacySnackBarModule,
      MatLegacyDialogModule,
      MatDialogModule
    ),
    provideOAuthClient(),
    { provide: OAuthStorage, useFactory: oauthStorageFactory },
    {
      provide: APP_INITIALIZER,
      useFactory: configureOAuthForIframe,
      deps: [OAuthService, CoreConfigurationService],
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi()),
    ProfileResolver,
    LoginGuard, 
    LunchGuard,
  ]
};
